module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"editTeamBtn":"Modifier"},"en":{"editTeamBtn":"Edit"}}')
  delete Component.options._Ctor
}
